


import echarts from 'echarts'

export default{
    data() {
        return {
            
        }
    },
    mounted() {
        const me = this;
        me.initChart();
    },
    methods: {
        initChart(){
            const me = this, box = me.$refs['sh_pie_chart'];
            let charts = echarts.init(box);
            charts.setOption({
                color: ['#00897B', '#2196f3', '#3f51b5', '#7b4ffc', '#ff54a8', '#e53935',
                '#8e24aa', '#009688', '#22bb87', '#8bc34a', '#cddc39', '#ffeb3b',
                '#ffc107', '#ff9800', '#ff5722', '#651fff', '#7c4dff', '#aa00ff',
                '#d81b60', '#512da8', '#00ac95', '#00c853', '#009688', '#0274a9',
                '#34be7c', '#43a047'],
                tooltip: {
                    trigger: 'item',
                    formatter: '{a} <br/>{b}: {c} ({d}%)'
                },
                legend: {
                    orient: 'vertical',
                    left: 10,
                    data: ['备案类', '审批类', '核准类']
                },
                series: [{
                        name: '项目数量',
                        type: 'pie',
                        radius: ['0%', '70%'],
                        label: {
                            show: true,
                            position: 'inner'
                        },
                        data: [
                            {value: 335, name: '备案类'},
                            {value: 310, name: '审批类'},
                            {value: 234, name: '核准类'},
                        ]
                    }]
                });
        }
    },
}


// WEBPACK FOOTER //
// ./src/components/base/view/cmps/charts/pie/src/pie.js